/**
 * Uses the Floating UI size plugin (https://floating-ui.com/docs/size) to ensure that select box
 * doesn't get cut off at the bottom of the browser viewport.
 */

import { autoUpdate, computePosition, size } from '@floating-ui/dom'
import { Hook, makeHook } from './Hook'

export default makeHook(
  class FloatingComboBox extends Hook {
    cleanup?: () => void

    mounted() {
      this.setupFloatingUI()
    }

    updated() {
      this.setupFloatingUI()
    }

    destroyed() {
      this.cleanup?.()
    }

    setupFloatingUI() {
      const floating = this.el.querySelector<HTMLElement>('[data-floating]')!
      const anchor = this.el.querySelector<HTMLElement>('[data-anchor]')!

      if (this.cleanup) {
        this.cleanup()
        this.cleanup = undefined
      }

      const updatePosition = async () => {
        const { x, y } = await computePosition(anchor, floating, {
          middleware: [
            size({
              apply({ availableHeight, elements }) {
                Object.assign(elements.floating.style, {
                  maxHeight: `${Math.min(300, Math.max(0, availableHeight))}px`,
                })
              },
              padding: 20,
            }),
          ],
        })

        Object.assign(floating.style, {
          left: `${x}px`,
          top: `${y}px`,
        })
      }

      updatePosition()
      this.cleanup = autoUpdate(anchor, floating, updatePosition)
    }
  }
)
